export default "__VITE_ASSET__6923b2b1__"